import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { environment } from 'src/environments/environment';
var CommonService = /** @class */ (function () {
    function CommonService(router, route, http, toastr) {
        this.router = router;
        this.route = route;
        this.http = http;
        this.toastr = toastr;
        this.env = environment;
        this.subject = new Subject();
    }
    CommonService.prototype.sendMessage = function (command, message) {
        this.subject.next({
            command: command,
            text: message
        });
    };
    CommonService.prototype.getMessage = function () {
        return this.subject.asObservable();
    };
    CommonService.prototype.goto = function (page) {
        try {
            this.router.navigate([page], { relativeTo: this.route });
        }
        catch (error) {
        }
    };
    CommonService.prototype.getConfig = function () {
        return JSON.parse(sessionStorage.getItem('config'));
    };
    CommonService.prototype.checkPermission = function (permissonName) {
        for (var i = 0; i < permissonName.length; i++) {
            try {
                if (this.getConfig().scope.includes(permissonName[i])) {
                    return true;
                }
            }
            catch (error) {
                return true;
            }
        }
        return false;
    };
    //serverURL
    CommonService.prototype.getUrl = function () {
        return this.env.url;
    };
    // http get data
    CommonService.prototype.getHtpp = function (url, header) {
        var _this = this;
        if (!header) {
            header = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Bearer ' + this.getConfig().access_token
                }
            };
        }
        return new Promise(function (resolve, reject) { return _this.http.get(_this.env.url + url, header).subscribe(function (data) {
            resolve(data);
        }); });
    };
    CommonService.prototype.postHtpp = function (url, body) {
        var _this = this;
        var options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + this.getConfig().access_token
            })
        };
        return new Promise(function (resolve, reject) { return _this.http.post(_this.env.url + url, body, options).subscribe(function (req) {
            resolve(req);
        }, function (error) {
            console.log(error);
            reject(error);
        }); });
    };
    CommonService.prototype.postHtppLogin = function (url, body) {
        var _this = this;
        var options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        return new Promise(function (resolve, reject) { return _this.http.post(_this.env.url + url, body, options).subscribe(function (req) {
            resolve(req);
        }, function (error) {
            console.log(error);
            reject(error);
        }); });
    };
    CommonService.prototype.putHtpp = function (url, body, header) {
        var _this = this;
        if (!header) {
            header = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Bearer ' + this.getConfig().access_token
                }
            };
        }
        return new Promise(function (resolve, reject) { return _this.http.put(_this.env.url + url, body, header).subscribe(function (req) {
            resolve(req);
        }, function (error) {
            console.log(error);
            reject(error);
        }); });
    };
    CommonService.prototype.deleteHtpp = function (url) {
        var _this = this;
        var options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + this.getConfig().access_token
            })
        };
        return new Promise(function (resolve, reject) { return _this.http.delete(_this.env.url + url, options).subscribe(function (req) {
            resolve(req);
        }, function (error) {
            console.log(error);
            reject(error);
        }); });
    };
    CommonService.prototype.checkinput = function (text, command, number) {
        if (command == '==' && text) {
            if (text.length == number) {
                return true;
            }
            else {
                return false;
            }
        }
        else if (command == '>' && text) {
            if (text.length > number) {
                return true;
            }
            else {
                return false;
            }
        }
        else if (command == '<' && text) {
            if (text.length < number) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    };
    CommonService.prototype.removeDuplicates = function (originalArray, prop) {
        var newArray = [];
        var lookupObject = {};
        for (var i in originalArray) {
            lookupObject[originalArray[i][prop]] = originalArray[i];
        }
        for (i in lookupObject) {
            newArray.push(lookupObject[i]);
        }
        return newArray;
    };
    CommonService.prototype.showAttr = function (data, name) {
        if (data) {
            for (var key in data) {
                if (key == name) {
                    return data[key];
                }
            }
            return '';
        }
        else {
            return '';
        }
    };
    CommonService = tslib_1.__decorate([
        Injectable({
            providedIn: 'root'
        }),
        tslib_1.__metadata("design:paramtypes", [Router,
            ActivatedRoute,
            HttpClient,
            ToastrService])
    ], CommonService);
    return CommonService;
}());
export { CommonService };
//# sourceMappingURL=common.service.js.map